import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
  standalone: false,
})
export class ButtonComponent implements OnInit {
  @Input() innerText: string = "";
  @Input() backgroundColor?: string = "";
  @Input() loading?: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() typeNumber?: number = 0;
  @Input() styles?: { [key: string]: string };
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}
  ngOnInit() {}
  handleClick() {
    this.onClick.emit();
  }
  
  getSpinnerColor(): string {
    // Return appropriate color based on button style
    if (this.typeNumber === 2) {
      return 'white'; // For button-style-1 (blue background)
    } else if (this.typeNumber === 1) {
      return 'black'; // For button-style-2 (white background with blue border)
    } else if (this.styles?.['class'] === 'cancle-btn') {
      return 'white'; // For cancel button (dark blue background)
    }
    return 'white'; // Default
  }
}
